import { getSelectedTableView, getListViewState, isItemPartOperation, isSingleItemSelection } from "owa-mail-list-store";
import { lazyMoveItemsBasedOnNodeIds, lazyArchiveMailListRows } from "owa-mail-triage-action";
import { resetFocus } from "owa-mail-focus-manager";
import folderNameToId from "owa-session-store/lib/utils/folderNameToId";
import type { ActionSource } from "owa-analytics-types";
import { lazyOnSingleSelectionChanged } from "owa-mail-mark-read-actions";
import { startAnimationOrHandleActionAsNeeded } from "owa-mail-list-item-animation-store";
import getSelectedFolderMailboxInfoOrDefault from "owa-mail-store/lib/utils/getSelectedFolderMailboxInfoOrDefault";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";

export default async function onArchive(actionSource: ActionSource): Promise<void> {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    if (!tableView) {
        return;
    }
    const rowKeys = getEffectiveRowKeys(tableView);
    const nodeIds = actionSource === "ContextMenu"
        ? getListViewState().expandedConversationViewState.allNodeIds
        : getListViewState().expandedConversationViewState.selectedNodeIds;
    let handleArchive: () => void;
    //Mark as read when archive from menu, only when a single item is selected, since that is the
    //only case where the item is shown in the reading pane.
    if (isSingleItemSelection(tableView)) {
        const selectedRowKey = [...tableView.selectedRowKeys.keys()][0];
        lazyOnSingleSelectionChanged.importAndExecute(selectedRowKey, tableView, true);
    }
    
    if (isItemPartOperation()) {
        const moveItemsBasedOnNodeIds = await lazyMoveItemsBasedOnNodeIds.import();
        handleArchive = () => {
            moveItemsBasedOnNodeIds(nodeIds, folderNameToId("archive", getSelectedFolderMailboxInfoOrDefault()), tableView.id, actionSource);
            resetFocus("onArchive");
        };
    }
    else {
        handleArchive = () => {
            // This calls into startAnimationOrHandleActionAsNeeded which
            // handles calling resetFocus (with or without animations enabled), so
            // we don't need to call resetFocus here.
            lazyArchiveMailListRows.importAndExecute(rowKeys, tableView, actionSource);
        };
    }
    
    if (!isItemPartOperation()) {
        startAnimationOrHandleActionAsNeeded("Archive" /*actionId*/, rowKeys, actionSource, false /*isActionTakenFromDialog*/, handleArchive);
    }
    else {
        handleArchive();
    }
}
